module.exports = __webpack_public_path__ + "static/img/observe-shi-logo-2.8f6ff007.png";